// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import {randomElementFromArray} from '../core/Utilities';
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import ContentData from '../core/ContentData';
import CoreStyles from '../core/Styles';
import {HeadingMediumText, LabelMediumText} from '../core/Type';
import {FixedSpace} from '../core/Spacing';
// Layouts
import {CssGrid, CssGridRow, CssGridColumn, CssGridSpace} from '../layouts/CssGrid';
import OneColumnLayout from '../layouts/OneColumnLayout';
import ThreeColumnLayout from '../layouts/ThreeColumnLayout';
// Modules
import CircularTopicIcon from '../modules/CircularTopicIcon';


export default class UpsellCards extends React.Component {
    static Variant = {
        Subject: "subject", // Default
        Mission: "mission",
    }

    render() {
        const styles = createExpandableMediaQueryStylesheet({
            module: {
                width: "100%",
                paddingTop: CoreMetrics.ElementSpacing.XLarge(),
            },
        });

        const {variant} = this.props;

        return <div className={css(styles.module)}>
            {variant === UpsellCards.Variant.Mission && <OneColumnLayout
                column1={<HeadingMediumText>Recent missions</HeadingMediumText>}
            />}

            {variant === UpsellCards.Variant.Mission && <FixedSpace
                variant={FixedSpace.Variant.Vertical}
                size={FixedSpace.Size.Large}
            />}

            <ThreeColumnLayout
                column1={<UpsellCard variant={variant} index={0} />}
                column2={<UpsellCard variant={variant} index={1} />}
                column3={<UpsellCard variant={variant} index={2} />}
            />
        </div>;
    }
}
UpsellCards.defaultProps = {
    variant: UpsellCards.Variant.Subject,
};

class UpsellCard extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                backgroundColor: CoreMetrics.Color.Neutral.OffWhite,
                padding: CoreMetrics.ElementPadding.Medium(),
                borderRadius: CoreMetrics.CornerRadius,
                height: 120,

                [CoreMetrics.MediaQuery().Phone]: {
                    height: 80,
                },
            },
            subject: {
                backgroundColor: CoreMetrics.Color.Neutral.White,
            },
            mission: {
                backgroundColor: "#f6f7f7",
            },
            topicIcon: {
                [CoreMetrics.MediaQuery().Tablet]: {
                    minWidth: 0,
                },
            },
            textContainer: {
                display: "flex",
                flexDirection: "column",
                // HACK(diedra): This module doesn't match the grid exactly -
                // the icon pushes out into the gutter by design, so we have
                // to use negative margin to kinda sorta line up the element
                // next to it with the grid.
                // And our core metrics don't work with negative numbers, so
                // the value itself is being used instead of
                // CoreMetrics.ElementPadding.XLarge().
                marginLeft: -48,

                [CoreMetrics.MediaQuery().Tablet]: {
                    marginLeft: 0,
                    minWidth: 0,
                },
            },
            headline: {
                fontWeight: "bold",
            },
        });

        const subjectUpsellStrings = [
            {
                headline: "Start from the basics",
                description: "Learn the basics, starting with"
                     + ` ${randomElementFromArray(ContentData.Units)}`,
            },
            {
                headline: "Practice for your next test",
                description: `Get some practice with 101 different exercises`,
            },
            {
                headline: "Let us guide the way",
                description: "Sign up and start a mission, your personalized"
                    + " learning journey",
            },
        ];

        const {variant, index} = this.props;

        const tabletSideSpace = <CssGridSpace size={0} sizeTablet={2} />;

        return <CssGrid
            size={4}
            sizeTablet={12}
            styles={[
                styles.container,
                CoreStyles.hairlineInnerStroke,
                variant === UpsellCards.Variant.Mission
                    ? styles.mission
                    : styles.subject,
            ]}
        >
            <CssGridRow>
                {tabletSideSpace}

                <CssGridColumn size={1} styles={[styles.topicIcon]}>
                    <CircularTopicIcon />
                </CssGridColumn>

                <CssGridColumn size={3} sizeTablet={7}>
                    <div className={css(styles.textContainer)}>
                        <LabelMediumText styles={[styles.headline]}>
                            {variant === UpsellCards.Variant.Mission
                                ? randomElementFromArray(ContentData.Subjects)
                                : subjectUpsellStrings[index].headline
                            }
                        </LabelMediumText>

                        <FixedSpace
                            variant={FixedSpace.Variant.Vertical}
                            size={FixedSpace.Size.XXSmall}
                        />

                        <LabelMediumText>
                            {variant === UpsellCards.Variant.Mission
                                ? "3% progress"
                                : subjectUpsellStrings[index].description
                            }
                        </LabelMediumText>

                        {variant === UpsellCards.Variant.Mission && <FixedSpace
                            variant={FixedSpace.Variant.Vertical}
                            size={FixedSpace.Size.XXSmall}
                        />}

                        {variant === UpsellCards.Variant.Mission &&
                            <LabelMediumText>
                                3 / 105 skills mastered
                            </LabelMediumText>
                        }
                    </div>
                </CssGridColumn>

                {tabletSideSpace}
            </CssGridRow>
        </CssGrid>;
    }
}



// WEBPACK FOOTER //
// ./src/modules/UpsellCards.jsx